import { Badge, Button, Icon, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { BasketButton } from './button';

interface SectionHeaderWrapperProps {
  title: string;
  statusIsStart: boolean;
  statusIsComplete: boolean;
  itemCount: number;
  onPressBasketButton: () => void;
  onAdd: () => void;
  onEdit: () => void;
}

export const SectionHeaderWrapper: React.FC<SectionHeaderWrapperProps> = ({
  title,
  statusIsComplete,
  statusIsStart,
  itemCount,
  onAdd,
  onEdit,
  onPressBasketButton,
}) => {
  return (
    <VStack p={Spacing['stack.xxs']} borderBottomWidth="1px" borderBottomColor="neutral.light">
      <HStack alignItems="center" justifyContent="space-between">
        <Text
          fontSize={Typography['fontsize.lg']}
          variant="semibold"
          color="brand.primary.principal">
          {title}
        </Text>
        {statusIsStart && <BasketButton count={itemCount} onPress={onPressBasketButton} />}
        {statusIsComplete && (
          <HStack alignItems="center" space={Spacing['inline.nano']}>
            <Badge
              testId="badge-resume-batch-ticket"
              backgroundColor="feedback.success.default"
              textColor="neutral.white">
              Concluído
            </Badge>
            <Button
              variant="textLink"
              onPress={onAdd}
              rightIcon={
                <Icon name="Addition" size="xxxs" color={Color['brand.tertiary.principal']} />
              }
              _text={{ fontFamily: Typography['fontfamily.base.semibold'] }}>
              ADICIONAR
            </Button>
            <Button
              color="brand.tertiary.principal"
              variant="textLink"
              onPress={onEdit}
              _text={{ fontFamily: Typography['fontfamily.base.semibold'] }}
              rightIcon={
                <Icon
                  name="EditPen"
                  size="xxxs"
                  testID="icon"
                  color={Color['brand.tertiary.principal']}
                />
              }>
              EDITAR LISTA
            </Button>
          </HStack>
        )}
      </HStack>
    </VStack>
  );
};
